import { render, staticRenderFns } from "./dashboard-module-shared-widgets-pending-widget.vue?vue&type=template&id=336279b7&scoped=true&"
import script from "./dashboard-module-shared-widgets-pending-widget.ts?vue&type=script&lang=ts&"
export * from "./dashboard-module-shared-widgets-pending-widget.ts?vue&type=script&lang=ts&"
import style0 from "./dashboard-module-shared-widgets-pending-widget.scss?vue&type=style&index=0&id=336279b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336279b7",
  null
  
)

export default component.exports